import * as React from 'react';
import Svg, {Path, SvgProps} from 'react-native-svg';

const SvgComponent = (props: SvgProps) => (
  <Svg
    width={22}
    height={23}
    viewBox="0 0 22 23"
    {...props}
    fill="none"
    stroke="none">
    <Path
      stroke={props.fill || '#070A7A'}
      strokeLinecap="round"
      strokeWidth={2}
      d="m1.35 21.109 19.39-19.39M1.35 1.707l19.39 19.39"
    />
  </Svg>
);
export default SvgComponent;
